'use strict';
var PropTypes = require('prop-types');

var __assign =
  (void 0 && (void 0).__assign) ||
  function () {
    __assign =
      Object.assign ||
      function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];

          for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
          }
        }

        return t;
      };

    return __assign.apply(this, arguments);
  };

var __createBinding =
  (void 0 && (void 0).__createBinding) ||
  (Object.create
    ? function (o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        Object.defineProperty(o, k2, {
          enumerable: true,
          get: function get() {
            return m[k];
          },
        });
      }
    : function (o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        o[k2] = m[k];
      });

var __setModuleDefault =
  (void 0 && (void 0).__setModuleDefault) ||
  (Object.create
    ? function (o, v) {
        Object.defineProperty(o, 'default', {
          enumerable: true,
          value: v,
        });
      }
    : function (o, v) {
        o['default'] = v;
      });

var __importStar =
  (void 0 && (void 0).__importStar) ||
  function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null)
      for (var k in mod) {
        if (k !== 'default' && Object.prototype.hasOwnProperty.call(mod, k))
          __createBinding(result, mod, k);
      }

    __setModuleDefault(result, mod);

    return result;
  };

var __rest =
  (void 0 && (void 0).__rest) ||
  function (s, e) {
    var t = {};

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }

    if (s != null && typeof Object.getOwnPropertySymbols === 'function')
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
          t[p[i]] = s[p[i]];
      }
    return t;
  };

var __importDefault =
  (void 0 && (void 0).__importDefault) ||
  function (mod) {
    return mod && mod.__esModule
      ? mod
      : {
          default: mod,
        };
  };

Object.defineProperty(exports, '__esModule', {
  value: true,
});

var react_1 = __importStar(require('react'));

var components_1 = require('../../../constants/components');

var useCombinedRefs_1 = require('../../../hooks/useCombinedRefs');

var useThemeContext_1 = require('../../../hooks/useThemeContext');

var useFocus_1 = require('../../../hooks/useFocus');

var useValidation_1 = require('../../../hooks/useValidation');

var useTransformation_1 = require('../../../hooks/useTransformation');

var function_1 = require('../../../utils/function');

var input_1 = require('../../../utils/input');

var BaseInput_1 = __importDefault(require('../../Base/BaseInput/BaseInput'));

var Input = react_1.forwardRef(function Input(props, ref) {
  var themeConfig = useThemeContext_1.useThemeContext().themeConfig;

  var _a = props.shape,
    shape = _a === void 0 ? themeConfig.shape : _a,
    _b = props.color,
    color = _b === void 0 ? components_1.BASE_COLORS.primary2 : _b,
    inputValue = props.value,
    label = props.label,
    _c = props.hideLabel,
    hideLabel = _c === void 0 ? false : _c,
    _d = props.fixedLabel,
    fixedLabel = _d === void 0 ? false : _d,
    hint = props.hint,
    inputError = props.error,
    _e = props.disabled,
    disabled = _e === void 0 ? false : _e,
    _f = props.clearable,
    clearable = _f === void 0 ? false : _f,
    icon = props.icon,
    _g = props.onIconClick,
    onIconClick = _g === void 0 ? function_1.noop : _g,
    defaultValue = props.defaultValue,
    inputControl = props.inputControl,
    _h = props.validationRules,
    validationRules = _h === void 0 ? [] : _h,
    _j = props.transformationRule,
    transformationRule = _j === void 0 ? input_1.defaultTrasformationRule : _j,
    _k = props.onBlur,
    onPropsBlur = _k === void 0 ? function_1.noop : _k,
    _l = props.onFocus,
    onPropFocus = _l === void 0 ? function_1.noop : _l,
    _m = props.onChange,
    onChange = _m === void 0 ? function_1.noop : _m,
    placeholder = props.placeholder,
    _o = props.onClear,
    onClear = _o === void 0 ? function_1.noop : _o,
    forceError = props.forceError,
    restProps = __rest(props, [
      'shape',
      'color',
      'value',
      'label',
      'hideLabel',
      'fixedLabel',
      'hint',
      'error',
      'disabled',
      'clearable',
      'icon',
      'onIconClick',
      'defaultValue',
      'inputControl',
      'validationRules',
      'transformationRule',
      'onBlur',
      'onFocus',
      'onChange',
      'placeholder',
      'onClear',
      'forceError',
    ]);

  var internalRef = react_1.useRef(null);
  var inputRef = useCombinedRefs_1.useCombinedRefs(ref, internalRef);

  var _p = react_1.useState(transformationRule.transform(defaultValue)),
    value = _p[0],
    setValue = _p[1];

  var _q = useFocus_1.useFocus({
      onBlur: onPropsBlur,
      onFocus: onPropFocus,
    }),
    focused = _q.focused,
    onBlur = _q.onBlur,
    onFocus = _q.onFocus;

  var _r = useValidation_1.useValidation({
      validationRules: validationRules,
      error: inputError,
      forceError: forceError,
    }),
    error = _r.error,
    validateoOnChange = _r.validateoOnChange,
    validateOnBlur = _r.validateOnBlur;

  var _s = useTransformation_1.useTransformation({
      transformationRule: transformationRule,
      onChange: onChange,
      setValue: setValue,
    }),
    transformOnChange = _s.transformOnChange,
    transformOnBlur = _s.transformOnBlur;

  react_1.useEffect(
    function () {
      var formattedValue = transformationRule.transform(inputValue);

      if (inputValue !== undefined && formattedValue !== value) {
        setValue(formattedValue);
      }
    },
    [value, inputValue, transformationRule]
  );
  react_1.useEffect(function () {
    if (forceError) {
      validateOnBlur(value);
    }
  });

  var handleChange = function handleChange(event) {
    validateoOnChange(event.target.value);
    transformOnChange(event);
  };

  var handleBlur = function handleBlur(event) {
    validateOnBlur(value);
    transformOnBlur(value);
    onBlur(event);
  };

  var handleClear = function handleClear(e) {
    setValue('');
    input_1.resolveOnChange(inputRef.current, e, onChange);
    onClear(e);
  };

  return react_1.default.createElement(
    BaseInput_1.default,
    __assign(
      {
        ref: inputRef,
        shape: shape,
        color: color,
        value: value,
        label: label,
        fixedLabel: fixedLabel || (!!label && !hideLabel && !!placeholder),
        hideLabel: hideLabel,
        hint: hint,
        error: error,
        focused: focused,
        disabled: disabled,
        clearable: clearable,
        placeholder: placeholder,
        onClear: handleClear,
        icon: icon,
        onIconClick: onIconClick,
        inputControl: inputControl,
        onChange: handleChange,
        onBlur: handleBlur,
        onFocus: onFocus,
      },
      restProps
    )
  );
});

Input.propTypes = {
  /**
   * В значении true, при заполнении поля, появится иконка для удаления данных
   * @default false
   */
  clearable: PropTypes.bool,
  /**
   * Задает основной цвет для инпута
   *  @default primary2
   */
  color: PropTypes.oneOf(['primary1', 'primary2', 'secondary1', 'secondary2']),
  /**
   * Задает значение по умолчанию, для неуправляемых компонентов.
   *  Не используется вместе с value
   */
  defaultValue: PropTypes.string,
  /**
   * Устанавливает атрибут disabled
   * @default false
   */
  disabled: PropTypes.bool,
  /**
   * Отображает ошибку заполнения поля
   */
  error: PropTypes.string,
  /**
   * Отображает label всегда сверху
   * @default false
   */
  fixedLabel: PropTypes.bool,
  /**
   * Параметр принудительного отображения ошибки
   */
  forceError: PropTypes.bool,
  /**
   * Прячет label, но оставляет поле доступным, добавляет аттрибут aria-label
   * @default false
   */
  hideLabel: PropTypes.bool,
  /**
   * Отображает подсказку для заполнения поля
   */
  hint: PropTypes.string,
  /**
   * Добавляет иконку
   */
  icon: PropTypes.node,
  /**
   * инпут контрол - по умолчанию StyledInput
   */
  inputControl: PropTypes.oneOfType([
    PropTypes.oneOf([
      'a',
      'abbr',
      'address',
      'animate',
      'animateMotion',
      'animateTransform',
      'area',
      'article',
      'aside',
      'audio',
      'b',
      'base',
      'bdi',
      'bdo',
      'big',
      'blockquote',
      'body',
      'br',
      'button',
      'canvas',
      'caption',
      'circle',
      'cite',
      'clipPath',
      'code',
      'col',
      'colgroup',
      'data',
      'datalist',
      'dd',
      'defs',
      'del',
      'desc',
      'details',
      'dfn',
      'dialog',
      'div',
      'dl',
      'dt',
      'ellipse',
      'em',
      'embed',
      'feBlend',
      'feColorMatrix',
      'feComponentTransfer',
      'feComposite',
      'feConvolveMatrix',
      'feDiffuseLighting',
      'feDisplacementMap',
      'feDistantLight',
      'feDropShadow',
      'feFlood',
      'feFuncA',
      'feFuncB',
      'feFuncG',
      'feFuncR',
      'feGaussianBlur',
      'feImage',
      'feMerge',
      'feMergeNode',
      'feMorphology',
      'feOffset',
      'fePointLight',
      'feSpecularLighting',
      'feSpotLight',
      'feTile',
      'feTurbulence',
      'fieldset',
      'figcaption',
      'figure',
      'filter',
      'footer',
      'foreignObject',
      'form',
      'g',
      'h1',
      'h2',
      'h3',
      'h4',
      'h5',
      'h6',
      'head',
      'header',
      'hgroup',
      'hr',
      'html',
      'i',
      'iframe',
      'image',
      'img',
      'input',
      'ins',
      'kbd',
      'keygen',
      'label',
      'legend',
      'li',
      'line',
      'linearGradient',
      'link',
      'main',
      'map',
      'mark',
      'marker',
      'mask',
      'menu',
      'menuitem',
      'meta',
      'metadata',
      'meter',
      'mpath',
      'nav',
      'noindex',
      'noscript',
      'object',
      'ol',
      'optgroup',
      'option',
      'output',
      'p',
      'param',
      'path',
      'pattern',
      'picture',
      'polygon',
      'polyline',
      'pre',
      'progress',
      'q',
      'radialGradient',
      'rect',
      'rp',
      'rt',
      'ruby',
      's',
      'samp',
      'script',
      'section',
      'select',
      'slot',
      'small',
      'source',
      'span',
      'stop',
      'strong',
      'style',
      'sub',
      'summary',
      'sup',
      'svg',
      'switch',
      'symbol',
      'table',
      'tbody',
      'td',
      'template',
      'text',
      'textarea',
      'textPath',
      'tfoot',
      'th',
      'thead',
      'time',
      'title',
      'tr',
      'track',
      'tspan',
      'u',
      'ul',
      'use',
      'var',
      'video',
      'view',
      'wbr',
      'webview',
    ]),
    PropTypes.func,
    PropTypes.shape({
      childContextTypes: PropTypes.object,
      contextType: PropTypes.shape({
        Consumer: PropTypes.func.isRequired,
        displayName: PropTypes.string,
        Provider: PropTypes.func.isRequired,
      }),
      contextTypes: PropTypes.object,
      defaultProps: PropTypes.object,
      displayName: PropTypes.string,
      getDerivedStateFromError: PropTypes.func,
      getDerivedStateFromProps: PropTypes.func,
      propTypes: PropTypes.object,
    }),
  ]),
  /**
   * Задает label
   */
  label: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  /**
   * Callback функция, вызываемая при очищении поля
   */
  onClear: PropTypes.func,
  onFocus: PropTypes.func,
  /**
   * Callback функция, вызываемая при клике на иконку
   */
  onIconClick: PropTypes.func,
  placeholder: PropTypes.string,
  /**
   * Задает скругление, значение по умолчанию берется из темы
   */
  shape: PropTypes.oneOf(['circular', 'geometric', 'rounded']),
  /**
   * Задаёт правила трансформации
   *
   * @param transform - метод, изменяющий значение при вводе
   * @param onBlurTransform - метод, изменяющий значение при потере фокуса
   */
  transformationRule: PropTypes.shape({
    onBlurTransform: PropTypes.func,
    transform: PropTypes.func.isRequired,
  }),
  /**
   * Задаёт правила валидации , а также содержит в себе текст ошибки
   * @param error - текстовое значение ошибки валидации
   * @param validate - метод, валидирующий значение value
   */
  validationRules: PropTypes.arrayOf(
    PropTypes.shape({
      error: PropTypes.string,
      validate: PropTypes.func.isRequired,
    })
  ),
  /**
   * Задает значение компонента, используется для управляемых компонентов.
   *  Не используется вместе с defaultValue
   */
  value: PropTypes.string,
};

exports.default = Input;
